<dashboardnav>
  
    <cradua-itemtype
        [itemtypes]="itemtypes$ | async"
        (itemtype)="onSubmitItemType($event)"
        (deleteItemTypeEvent)="onDeleteItemType($event)"
        *ngIf="(isLoading$ | async ) === false"
        >
  </cradua-itemtype>
  
    <mrsoftapps-epims-reference-spinner
    *ngIf="(isLoading$ | async) === true"
  >
    </mrsoftapps-epims-reference-spinner>
    <!-- <pre>{{isLoading$ | async | json}}</pre> -->
  </dashboardnav>
  